import React, { useState } from "react";
import axios from "axios";
import { config } from "../../../config";

const apiUrl = config.apiUrl;

const CreateMenu = ({ onMenuCreated }) => {
  const [formData, setFormData] = useState({
    name: "",
    url: "",
    menu_type: "header", // default value
    order: 1,
  });
  const [error, setError] = useState(null);
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ 
      ...prev, 
      [name]: name === "order" ? parseInt(value) : value 
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${apiUrl}/menus`, formData);
      alert("Menu Created Successfully!");
      onMenuCreated();
    } catch (err) {
      console.error("API Error:", err.response ? err.response.data : err.message);
      setError("An error occurred while creating the Menu.");
    }
  };

  return (
    <div className="p-6 max-w-md mx-auto bg-white shadow rounded">
      <h2 className="text-2xl font-bold mb-4">Create Menu</h2>
      {error && <p className="text-red-500">{error}</p>}
      <form onSubmit={handleSubmit}>
        <div className="mb-4">
          <label className="block text-gray-700">Name</label>
          <input
            name="name"
            value={formData.name}
            onChange={handleChange}
            className="border w-full p-2"
            required
            maxLength="255"
          />
        </div>

        <div className="mb-4">
          <label className="block text-gray-700">URL</label>
          <input
            type="url"
            name="url"
            value={formData.url}
            onChange={handleChange}
            className="border w-full p-2"
            required
            maxLength="500"
          />
        </div>

        <div className="mb-4">
          <label className="block text-gray-700">Menu Type</label>
          <select
            name="menu_type"
            value={formData.menu_type}
            onChange={handleChange}
            className="border w-full p-2"
            required
          >
            <option value="header">Header</option>
            <option value="footer">Footer</option>
            <option value="sidebar">Sidebar</option>
          </select>
        </div>

        <div className="mb-4">
          <label className="block text-gray-700">Order</label>
          <input
            type="number"
            name="order"
            value={formData.order}
            onChange={handleChange}
            className="border w-full p-2"
            min="1"
            required
          />
        </div>

        <button
          type="submit"
          className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
        >
          Create Menu
        </button>
      </form>
    </div>
  );
};

export default CreateMenu;